import * as constants from 'common/constants';
export const DEFAULT_STATE = {
  features: {
    allowUploadShapefile: false,
    showTutorials: false,
  },
  isOnline: true,
  season: new Date().getFullYear(),
  updatingCropPrices: false,
  maxPlantingArea: 0,
};

export default (state = DEFAULT_STATE, { type, payload }) => {
  switch (type) {
    case constants.UPDATE_SEASON:
      return {
        ...state,
        season: payload,
      };
    case constants.UPDATE_NETWORK_STATUS:
      return {
        ...state,
        isOnline: payload,
      };
    case constants.UPDATE_CROP_PRICE_STATUS:
      return {
        ...state,
        updatingCropPrices: payload,
      };
    case constants.UPDATE_FEATURES:
      return {
        ...state,
        features: {
          ...state.features,
          ...payload,
        },
      };
    case constants.UPDATE_MAX_PLANTING_AREA:
      return {
        ...state,
        maxPlantingArea: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/settings.js